// Utility to dynamically load CSS files without blocking initial render
const loadedCSS = new Set();

export const loadCSS = (cssPath) => {
  if (loadedCSS.has(cssPath)) {
    return Promise.resolve();
  }
  
  return new Promise((resolve, reject) => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = cssPath;
    link.onload = () => {
      loadedCSS.add(cssPath);
      resolve();
    };
    link.onerror = reject;
    document.head.appendChild(link);
  });
};

// // Load specific CSS bundles
// export const loadSlickCSS = () => {
//   return Promise.all([
//     import('slick-carousel/slick/slick.css'),
//     import('slick-carousel/slick/slick-theme.css')
//   ]);
// };

export const loadSwiperCSS = () => {
  return Promise.all([
    import('swiper/css'),
    import('swiper/css/pagination'), 
    import('swiper/css/navigation')
  ]);
};

export const loadBootstrapCSS = () => {
  return Promise.all([
    import('@fortawesome/fontawesome-free/css/all.min.css'),
    import('bootstrap-css-only/css/bootstrap.min.css'),
    import('mdbreact/dist/css/mdb.css')
  ]);
};

// Load all non-critical CSS after initial render
export const loadAllNonCriticalCSS = () => {
  // Use requestIdleCallback if available, otherwise setTimeout
  const loadCSS = () => {
    // Promise.all([
    //   loadSlickCSS(),
    //   loadSwiperCSS(), 
    //   loadBootstrapCSS()
    // ]).catch(console.error);

    setTimeout(() => loadBootstrapCSS().catch(console.error), 100);
    // setTimeout(() => loadSwiperCSS().catch(console.error), 250);
    // setTimeout(() => loadSlickCSS().catch(console.error), 400);
  };
  
  if (window.requestIdleCallback) {
    window.requestIdleCallback(loadCSS);
  } else {
    setTimeout(loadCSS, 0);
  }
};
